// extracted by mini-css-extract-plugin
export default {"container":"Blog_container__ijZ5+"};